var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 147,
    viewBox: "0 0 163 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_366_56498)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_366_56498",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 163,
    height: 147
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M163 0H0V147H163V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_366_56498)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8203 73.1185L99.4384 28.8584L22.8203 73.1185Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8203 73.1185L99.4384 28.8584",
    stroke: "#008243",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.0449 102.148L117.663 57.8877L41.0449 102.148Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0449 102.148L117.663 57.8877",
    stroke: "#667FF8",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.289 46.7654L143.26 43.2705L137.289 46.7654Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.289 46.7654L143.26 43.2705",
    stroke: "#008243",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.0742 126.03L126.263 91.8584L68.0742 126.03Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0742 126.03L126.263 91.8584",
    stroke: "#008243",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M141.058 93.3282C141.993 93.3972 142.698 94.2157 142.631 95.1546C142.563 96.0936 141.75 96.7999 140.815 96.7309C139.879 96.6618 139.175 95.8434 139.242 94.9044C139.309 93.9655 140.123 93.2592 141.058 93.3282Z",
    stroke: "#008243",
    strokeWidth: 4.28355
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1731 131.27C44.7109 131.383 45.8696 132.728 45.7591 134.273C45.6485 135.817 44.3101 136.978 42.7724 136.865C41.2346 136.752 40.0758 135.406 40.1864 133.862C40.2969 132.318 41.6353 131.156 43.1731 131.27Z",
    stroke: "#008243",
    strokeWidth: 7.044
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6125 15.0089C80.1503 15.1222 81.3091 16.4677 81.1985 18.0118C81.0879 19.5558 79.7496 20.7175 78.2118 20.6043C76.674 20.491 75.5152 19.1454 75.6258 17.6014C75.7364 16.0573 77.0747 14.8957 78.6125 15.0089Z",
    stroke: "#008243",
    strokeWidth: 7.044
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9122 51.4502C16.6161 51.4502 17.1876 52.0248 17.1876 52.7325C17.1876 53.4403 16.6161 54.0149 15.9122 54.0149C15.2082 54.0149 14.6367 53.4403 14.6367 52.7325C14.6367 52.0248 15.2082 51.4502 15.9122 51.4502Z",
    stroke: "#008243",
    strokeWidth: 5.14888
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.975 135.074C115.679 135.074 116.25 135.649 116.25 136.357C116.25 137.064 115.679 137.639 114.975 137.639C114.271 137.639 113.699 137.064 113.699 136.357C113.699 135.649 114.271 135.074 114.975 135.074Z",
    stroke: "#A4B3FD",
    strokeWidth: 5.14888
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.619 14.582L129.879 9.48907",
    stroke: "#008243",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.805 12.4053L132.87 11.661",
    stroke: "#008243",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2246 98.5596L21.2117 93.5143",
    stroke: "#008243",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2969 96.5391L24.315 95.5206",
    stroke: "#008243",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.734 120.737L127.257 115.809",
    stroke: "#008243",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.633 119L130.534 117.514",
    stroke: "#008243",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.523 36.499C101.837 36.499 118.331 53.082 118.331 73.5064C118.331 93.9308 101.837 110.514 81.523 110.514C61.2086 110.514 44.7148 93.9308 44.7148 73.5064C44.7148 53.082 61.2086 36.499 81.523 36.499Z",
    fill: "#61bf92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5007 39.999C99.8938 39.999 114.828 55.0136 114.828 73.5063C114.828 91.999 99.8938 107.014 81.5007 107.014C63.1076 107.014 48.1738 91.999 48.1738 73.5063C48.1738 55.0136 63.1076 39.999 81.5007 39.999Z",
    fill: "#276c4b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4492 74.7361L75.4593 83.589C75.4593 83.589 94.8241 64.1193 96.4435 62.4912",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_366_56498"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 163,
    height: 147,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentSuccess);
export default __webpack_public_path__ + "static/media/payment-success.9962256fcb607e21fba306e24c509ff4.svg";
export { ForwardRef as ReactComponent };